import type { Achievement } from "../achievement.types";
import { comebackKidAchievement } from "./comebackKid.definition";
import { offTheMapAchievement } from "./offTheMap.definition";
import { dejaVuAchievement } from "./dejaVu.definition";
import { turnedAroundAchievement } from "./turnedAround.definition";
import { hereBeDragonsAchievement } from "./hereBeDragons.definition";
import { neverLookedBackAchievement } from "./neverLookedBack.definition";
import { againstTheGrainAchievement } from "./againstTheGrain.definition";
import { notAllWhoWanderAreLostAchievement } from "./notAllWhoWanderAreLost.definition";
import { rareFindAchievement } from "./rareFind.definition";
import { qedAchievement } from "./qed.definition";
import { withinSightAchievement } from "./withinSight.definition";
import { slowAndSteadyAchievement } from "./slowAndSteady.definition";
import { secondThoughtsAchievement } from "./secondThoughts.definition";
import { straightAndNarrowAchievement } from "./straightAndNarrow.definition";
import { goldStandardAchievement } from "./goldStandard.definition";
import { iKnowAShortcutAchievement } from "./iKnowAShortcut.definition";
import { thoseWhoKnowAchievement } from "./thoseWhoKnow.definition";
import { seasonalExplorerAchievement } from "./seasonalExplorer.achievement";
import { aHundredLessonsAchievement } from "./aHundredLessons.definition";
import { tenStepsAheadAchievement } from "./tenStepsAhead.definition";
import { aStepAheadAchievement } from "./aStepAhead.definition";
import { wordCollectorAchievement } from "./wordCollector.achievement";
import { firstLightAchievement } from "./firstLight.definition";
import { surveyorAchievement } from "./surveyor.definition";
import { halfTheMapAchievement } from "./halfTheMap.definition";

export const allAchievements: Achievement[] = [
  straightAndNarrowAchievement,
  goldStandardAchievement,
  iKnowAShortcutAchievement,
  neverLookedBackAchievement,
  hereBeDragonsAchievement,
  offTheMapAchievement,
  notAllWhoWanderAreLostAchievement,
  withinSightAchievement,
  turnedAroundAchievement,
  comebackKidAchievement,
  dejaVuAchievement,
  slowAndSteadyAchievement,
  againstTheGrainAchievement,
  secondThoughtsAchievement,
  thoseWhoKnowAchievement,
  rareFindAchievement,
  seasonalExplorerAchievement,
  wordCollectorAchievement,
  aStepAheadAchievement,
  tenStepsAheadAchievement,
  aHundredLessonsAchievement,
  qedAchievement,
  firstLightAchievement,
  surveyorAchievement,
  halfTheMapAchievement,
];

// ============================================================================
// ACHIEVEMENT ID CHECK
// ============================================================================
// v2's ids (spec 2026-10-20 §3). Unlocks are stored by id; renaming one drops
// its stored unlocks (decision A1), so change this list only with the spec.

const STABLE_ACHIEVEMENT_IDS = [
  "straightAndNarrow",
  "goldStandard",
  "iKnowAShortcut",
  "neverLookedBack",
  "hereBeDragons",
  "offTheMap",
  "notAllWhoWanderAreLost",
  "withinSight",
  "turnedAround",
  "comebackKid",
  "dejaVu",
  "slowAndSteady",
  "againstTheGrain",
  "secondThoughts",
  "thoseWhoKnow",
  "rareFind",
  "seasonalExplorer",
  "wordCollector",
  "aStepAhead",
  "tenStepsAhead",
  "aHundredLessons",
  "qed",
  "firstLight",
  "surveyor",
  "halfTheMap",
] as const;

// Validate that achievement IDs match the stable list
if (process.env.NODE_ENV === "development") {
  const currentIds = allAchievements.map((a) => a.id).sort();
  const expectedIds = [...STABLE_ACHIEVEMENT_IDS].sort();

  if (JSON.stringify(currentIds) !== JSON.stringify(expectedIds)) {
    console.error("🚨 ACHIEVEMENT ID MISMATCH DETECTED!");
    console.error("Expected IDs:", expectedIds);
    console.error("Current IDs:", currentIds);
    console.error("This will break user progress! Fix immediately!");
  }
}

// Optionally, re-export all individual achievements if direct access is ever needed
export {
  straightAndNarrowAchievement,
  goldStandardAchievement,
  iKnowAShortcutAchievement,
  neverLookedBackAchievement,
  hereBeDragonsAchievement,
  offTheMapAchievement,
  notAllWhoWanderAreLostAchievement,
  withinSightAchievement,
  turnedAroundAchievement,
  comebackKidAchievement,
  dejaVuAchievement,
  slowAndSteadyAchievement,
  againstTheGrainAchievement,
  secondThoughtsAchievement,
  thoseWhoKnowAchievement,
  rareFindAchievement,
  seasonalExplorerAchievement,
  wordCollectorAchievement,
  aStepAheadAchievement,
  tenStepsAheadAchievement,
  aHundredLessonsAchievement,
  qedAchievement,
  firstLightAchievement,
  surveyorAchievement,
  halfTheMapAchievement,
};
